import { useSdkContext } from "~/components/contexts";
export const useGoogleOptimize = () => {
  const {
    acquisition: {
      getPersonalizationByExperimentId,
      getVariantByExperimentId,
      uiTestingState
    }
  } = useSdkContext();
  return {
    getPersonalizationByExperimentId,
    getVariantByExperimentId,
    uiTestingState
  };
};